import React, { useState, useEffect, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    createMeal,
    updateMeal,
    clearMessages as clearMealMessages
} from '../../../redux/slices/admin/mealsSlice';

const MealModal = ({ isOpen, closeModal, initialData, isEditMode }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        meal_name: '',
        type_id: '',
        instructions: '',
        meal_picture: null,
    });
    const [loading, setLoading] = useState(false);
    const successMessage = useSelector((state) => state.admin_meals?.successMessage);
    const errorMessage = useSelector((state) => state.admin_meals?.error);
    const mealTypes = useSelector((state) => state.app_options?.meal_types_min);
    const { currentMealPage } = useSelector((state) => state.admin_meals);

    useEffect(() => {
        if (isEditMode && initialData) {
            setFormData({
                meal_name: initialData.meal_name || '',
                type_id: initialData.type_id || '',
                instructions: initialData.instructions || '',
                meal_picture: null,
            });
        }
    }, [isEditMode, initialData]);

    const handleFormChange = (event) => {
        const { name, value, files } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: name === 'meal_picture' ? files[0] : value,
        }));
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        const form = new FormData();
        form.append('meal_name', formData.meal_name);
        form.append('meal_picture', formData.meal_picture);
        form.append('type_id', formData.type_id);
        form.append('instructions', formData.instructions);
        form.append('page', currentMealPage);

        if (isEditMode) {
            form.append('id', initialData.id);
        }
        try {
            if (isEditMode) {
                await dispatch(updateMeal({id:initialData.id, mealData:form}));
            } else {
                await dispatch(createMeal(form));
            }
            setFormData({
                meal_name: '',
                type_id: '',
                instructions: '',
                meal_picture: null,
            });
        } catch (error) {

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (successMessage) {
            setFormData({
                meal_name: '',
                type_id: '',
                instructions: '',
                meal_picture: null,
            });
        }
    }, [successMessage]);

    const handleClose = () => {
        dispatch(clearMealMessages());
        closeModal();
    };

      const fileInputRef = useRef(null);

  useEffect(() => {
    if (formData.meal_picture === null && fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }, [formData.meal_picture]);

    if (!isOpen) return null;

    return (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', paddingLeft: '0px' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-create" role="document">
                <div className="modal-content">
                    <div className="modal-header justify-content-center">
                        <h1 className="modal-title" id="createBackdropLabel">{isEditMode ? 'Edit Meal' : 'Add Meal'}</h1>
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>
                    <form onSubmit={handleFormSubmit}>
                        <div className="modal-body px-md-5 pb-md-4">
                            <div className="row g-3 gx-md-5 gy-md-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="meal_name"
                                        placeholder="Meal Name"
                                        className="form-control form-control-lg"
                                        value={formData.meal_name}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-12">
                                    <div className="col-md-12">
                                        <select
                                            className="form-select form-select-lg"
                                            name="type_id"
                                            onChange={handleFormChange}
                                            value={formData.type_id}
                                            required
                                        >
                                            <option value="">Type</option>
                                            {mealTypes?.map((mealType) => (
                                                <option key={mealType.id} value={mealType.id}>
                                                    {mealType.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                 <div className="col-md-12">
                                    <div className="col-md-12"> 
                                        <textarea
                                            className="form-control"
                                            name="instructions"
                                            placeholder="Enter instructions Here"
                                            onChange={handleFormChange}
                                            value={formData.instructions || ''}
                                            >{formData.instructions}</textarea>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <label>Picture</label>
                                    <div className="position-relative">
                                    <input
                                        type="file"
                                        name="meal_picture"
                                        className="form-control form-control-lg form-control-choose"
                                        ref={fileInputRef}
                                        onChange={handleFormChange}
                                        style={formData.meal_picture === null ? { borderColor: 'red' } : {}}
                                      />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12" style={{paddingTop:'10px'}}>
                                <button  style={{marginBottom:'10px'}} type="submit" className="btn btn-create w-100" disabled={loading}>
                                    {loading ? 'Loading...' : (isEditMode ? 'Update' : 'Create')}
                                </button>
                                {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
export default MealModal;